import { Routes } from '@angular/router';

export const paymentsRoutes: Routes = [
    {
        path: 'list',
        loadComponent: () =>
            import('./containers/payments-grid-view/payments-grid-view.component')
        .then((m) => m.PaymentsGridViewComponent),
    },
    {
        path: '**',
        redirectTo: 'list',
    },
];
